<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">站台管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="站台名称" prop="StationName">
            <el-input
              v-model="StationName"
              placeholder="请输入站台名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="站台类型">
            <el-select v-model="StationType" placeholder="请选择">
              <el-option
                v-for="item in StationTypeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="StationName"
                label="站台名称"
              ></el-table-column>
              <el-table-column
                prop="StationType"
                label="站台类型"
              ></el-table-column>
              <el-table-column
                prop="TicketPrice"
                label="票价"
              ></el-table-column>
              <el-table-column prop="Longitude" label="经度"></el-table-column>
              <el-table-column prop="Latitude" label="纬度"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "StationManagerView",
  controller: "UI",
  action: "StationManagerView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      StationName: "",
      StationType: "",
      StationTypeArr: [
        { value: "单行", label: "单行" },
        { value: "上行", label: "上行" },
        { value: "下行", label: "下行" },
      ],
    };
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "站台管理查询";
    this.logInfo.LogMessage = "站台管理查询";
    this.logInfo.ModuleName = "车辆调度";
    this.logInfo.PageName = "站台管理列表";
    this.addOperationLog();
  },
  methods: {
    search() {
      let searchInfo = {
        StationName: this.StationName,
        StationType: this.StationType,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.StationsApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/vehicleScheduling/UI/StationManagerInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/vehicleScheduling/ui/StationManagerInfo",
        query: { InfoId: row.Id, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/vehicleScheduling/ui/StationManagerInfo",
        query: { InfoId: row.Id, type: "edit" },
      });
    },
    //站台已维护线路，不能删除
    canDelete(selectData, callback) {
      let canDelete = true;
      new MyApis.LineStationRelationApi()
        .GetItemPagingList({
          StationId: selectData.Id,
        })
        .then((r) => {
          r = r.data.Data;
          const data = r.PageContents;
          if (data != null && data.length > 0) {
            this.$message.error("该站台已维护了线路，请先删除线路站台关系。");
            canDelete = false;
          }
          callback(canDelete);
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const that = this;
          that.canDelete(row, function(data) {
            if (data) {
              new MyApis.StationsApi()
                .DelItem(row)
                .then((r) => {
                  r = r.data.Data;
                  if (r) {
                    that.$message({
                      type: "success",
                      message: "删除成功!",
                    });
                    that.logInfo.ActionName = "站台删除";
                    that.logInfo.LogMessage = "站台删除成功";
                    that.logInfo.ModuleName = "车辆调度";
                    that.logInfo.PageName = "站台管理列表";
                    that.addOperationLog();
                  } else {
                    that.$message({
                      type: "error",
                      message: "删除失败!",
                    });
                  }
                  that.search();
                })
                .catch((e) => {
                  console.log(e);
                });
            } else {
              return;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.StationName = "";
      this.StationType = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
